import {configureStore} from '@reduxjs/toolkit'
import authReducer from '../slice/authSlice'
import googleMapReducer from '../map/googleMapReducer'
import genericFormReducer from '../reducer/genericFormReducer'
import commonFilterReducer from '../reducer/commonFilterReducer'
import homePageCardReducer from '../reducer/homePageCardReducer'
import homePageQuickLinkReducer from '../reducer/homePageQuickLinkReducer'
import supportingAppLinkReducer from '../reducer/supportingAppLinkReducer'
import {combineReducers} from 'redux'
import {useDispatch} from 'react-redux'
// import logger from 'redux-logger'

const rootReducer = combineReducers({
 googleMap: googleMapReducer,
 authReducer,
 genericFormReducer,
 commonFilterReducer,
 homePageCardReducer,
 homePageQuickLinkReducer,
 supportingAppLinkReducer,
})

export const store = configureStore({
 reducer: rootReducer,
 middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware(), // .concat(logger),
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

export const useAppDispatch = () =>
 useDispatch<AppDispatch>()
